module.exports = __webpack_public_path__ + "img/button_prefix_off.5f020204.svg";